// extracted by mini-css-extract-plugin
export default {"pagination":"SalesPagination_pagination__u5P98","arrow":"SalesPagination_arrow__HRFYU","label":"SalesPagination_label__rMLf0"};